import { useMutation } from '@tanstack/react-query';

import { getGestionPiloteeDetail } from '@/services/getGestionPiloteeDetail/getGestionPiloteeDetail';
import { PiloteManagementResponse } from '@/types/parcoursVersementTypes';
import { log } from '@/utils/functions/logger/logger';

interface GestionPilotee {
  codeSupport: string;
  profil: string;
  libelleSupport: string;
  gestionnaire: string;
  srri: number;
  type: string;
}
export const useGestionPilotee = () => {
  return useMutation<PiloteManagementResponse, Error, GestionPilotee>({
    mutationFn: getGestionPiloteeDetail,
    onError: (error) => {
      log.error(`useGestionPilotee failed: ${error}`);
    },
  });
};
